import { Sonda } from "./sonda";

export enum MethodType {
  POST = "POST",
  GET = "GET",
  PUT = "PUT",
  HEAD = "HEAD"
}

export interface BasicResponse {
  statusCode: number;
  statusText: string;
}
export interface MockStructure {
  statusCode: number;
  delay: number;
  rawResponse: string;
}

export interface Request {
  method: MethodType;
  endpoint: string;
  data: object;
  onError: Function;
  onTimeout: Function;
  onSuccess: Function;
  onRedirect: Function;
  onFetching: Function;
  sonda: Sonda;
  redirectAsReject: Boolean;
  headers: Object;
  dataStringify: Boolean;
  mockInfo: MockStructure;
  onLoadXhr: Function;
  cleanResponse(response: any): any;
  appendStatusVarsIfNeeded(data: any, basicResponse: BasicResponse): any;
  errorHandler(currentXhr: any): any;
  setRequestHeaders(headers: any, xhr: any);
  executeOnFetching(xhr: any);
  executeOnSuccess(xhr: any, response: any): any;
  executeOnRedirect(xhr: any, response: any): any;
  executeOnTimeout(xhr: any, headers: any, reject: Function);
  executeOnError(xhr: any, reject: Function);
  executeOnLoad(xhr: any, resolve: Function, reject: Function);
  sendXhrInfo(xhr: any);
  executeMock(mockInfo: MockStructure, resolve: Function, reject: Function): void;
  makeRequest(): Promise<any>;
}
